import { render, staticRenderFns } from "./DataFragment.vue?vue&type=template&id=6b108bb4&"
import script from "./DataFragment.vue?vue&type=script&lang=js&"
export * from "./DataFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports